import { Dropdown } from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';

import { MODES_REGLEMENTS_POINTAGE } from '@/constants';
import { ModeReglementContext } from '@/contexts';
import type { ModeReglementsPointageType } from '@/types';

type BordereauModeSelectorProps = {
  modeActif: ModeReglementsPointageType;
  disabled: boolean;
  loading: boolean;
  getTotalByCode: (code: ModeReglementsPointageType) => number;
  onModeChange: (event: unknown, data: Record<string, any>) => void;
};

const BordereauModeSelector = (props: BordereauModeSelectorProps) => {
  const { modeActif, disabled, loading, getTotalByCode, onModeChange } = props;

  const { regieModesReglement } = React.useContext(ModeReglementContext);

  const modeReglementsOptions = React.useMemo(
    () =>
      _.map(
        _.pickBy(MODES_REGLEMENTS_POINTAGE, (mode, code) => _.some(regieModesReglement, { code })),
        (mode, code) => ({
          key: code,
          text: mode,
          value: code,
          description: (
            <b
              title={`${getTotalByCode(code as ModeReglementsPointageType)} bordereau${getTotalByCode(code as ModeReglementsPointageType) > 1 ? 'x' : ''} pour ce mode de règlement`}
            >
              {getTotalByCode(code as ModeReglementsPointageType).toString()}
            </b>
          ),
        }),
      ),
    [regieModesReglement, getTotalByCode],
  );

  return (
    <div>
      <Dropdown
        selection
        disabled={disabled}
        loading={loading}
        options={modeReglementsOptions}
        defaultValue={modeActif}
        value={modeActif}
        onChange={onModeChange}
        closeOnChange
        openOnFocus
        style={{ marginLeft: '1em', marginRight: '1em' }}
      />
    </div>
  );
};

export default BordereauModeSelector;
